<template>
  <div class="lion-item cd">

    <div v-if="cfg_hide_header !== true" class="row-title mb-3 mx-3 d-flex align-items-center">
        
      <!--  -->
      <div v-if="cfg_show_breed_row" class="sp-price-block">
        <span class="sp-icon mr-2">
          <i class="fas fa-dollar-sign"></i>
        </span>
        <div style="line-height: 18px;">
          <div class="small">
            {{lg('',{
              en: 'BREED FEE',
              zh: '繁殖费用',
            })}}
          </div>
          <div class="c2">
            
            <span>
              {{data.auctionInfo.price}}
              {{data.auctionInfo.price_token}}
            </span>
            <small class="ml-1">
              <!-- todo... -->
              <!-- $18 -->
            </small>
          </div>
        </div>
      </div>
      <!--  -->
      <div v-else class="sp-price-block">
        <span class="sp-icon mr-2">
          <i class="fas fa-dollar-sign"></i>
        </span>
        <span class="mr-1 c">
          {{data.auctionInfo.price}}
          {{data.auctionInfo.price_token}}
        </span>
        <small style="font-size: 12px;">
          <!-- todo... -->
          <!-- $18 -->
        </small>
      </div>

      <div class="sp-like ml-auto">
        <i class="fa fa-heart"></i>
      </div>

    </div>

    <div 
      @click="gotoItem()"
      class="d-block row-img mx-3 cp"
      >
      <img 
        :src=" data.image_url || '/static/img/demo_lion_cover.png'"
        style="height: 250px; object-fit: cover;"
      >
    </div>

    <div 
      v-if="cfg_show_name_row" 
      class="mt-2 text-center d-flex align-items-center justify-content-center"
      style="height: 32px;"
      >

      <div 
        class="mt-1"
        v-if="cfg_give_name_available && !data.name && data.is_my" 
        >
        <span 
          class="btn btn-primary btn-sm"
          @click.stop="$store.commit('setDataBusKey',{
            data_on_give_name: data,
          })"
          >
          {{lg('',{
            en: 'Set Name',
            zh: '设置名字',
          })}}
        </span>
      </div>

      <div v-else>
        {{data.item_name}}
      </div>
    </div>

    <div 
      v-if="cfg_show_price_row" 
      class="mt-2 text-center d-flex align-items-center justify-content-center"
      style="height: 32px;"
      >
      <div 
        class="mt-1 c2 b"
        v-if="data.price > 0" 
        >
        {{data.price}} JGN
      </div>
    </div>

    <div 
     v-if="cfg_show_breed_row"
     class="mx-5 my-3"
     style="line-height: 15px;"
     >
      <div class="bg-white py-2 text-center">
        <div>
          {{lg('',{
            en: 'TIME LEFT',
            zh: '剩余时间',
          })}}
        </div>
        <div class="c2 mt-2">
          <!-- {{data.breedLimitInfo.left_str }} -->
          {{data.auctionInfo.timeLeft}}
          <!-- todo... -->
        </div>
      </div>
    </div>

    <div>
    </div>

    <div 
      class="row-bottom cp"
      @click="gotoItem()"
      >
      {{data.tokenID || '-'}}
    </div>
  </div>
</template>

<script>

export default {
  name: 'lionItem',
  components: {},
  props: [
    'data',
    'cfg_no_link',
    'cfg_show_name_row',
    'cfg_show_price_row',
    'cfg_give_name_available',
    'cfg_show_breed_row',
    'cfg_hide_header',
  ],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    gotoItem(){
      let v = this
      if(v.cfg_no_link){return}
      v.$router.push({
        name: 'lion_item',
        params: {
          id: v.data.tokenID,
        },
      })
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .lion-item{
    background-color: #E6E6E6;
    border-radius: 20px;
    padding-top: 25px;

    &.styled-2{
      .row-title{

        .sp-icon{
          background-color: $c2;
        }
        .sp-like{
          color: $c2;
        }
      }
      .row-bottom{
        background-color: $c2;
      }
      .row-img{
        img{
          border: 4px solid $c2;
        }
      }
    }

    .row-title{

      .sp-price-block{
        height: 40px;
        display: flex;
        align-items: center;
        background-color: #fff;
        padding: 10px;
        border-top-left-radius: 50px;
        border-bottom-left-radius: 50px;
      }

      .sp-icon{
        width: 30px;
        height: 30px;
        line-height: 30px;
        color: #fff;
        background-color: $c;
        text-align: center;
        border-radius: 30px;
      }

      .sp-like{
        display: inline-block;
        height: 40px;
        width: 40px;
        border-radius: 40px;
        line-height: 40px;
        text-align: center;
        color: $c;
        background-color: #fff;
      }
    }

    .row-img{
      min-height: 245px;
      margin: 0px 20px;
      overflow: hidden;

      img{
        border: 4px solid $c;
        border-radius: 10px;
        width: 100%;
        height: 100%;
        object-fit: cover;
        overflow: hidden;
      }
    }

    .row-bottom{
      color: #fff;
      background-color: $c;
      text-align: center;
      padding: 10px 0;
      border-radius: 15px;
      font-weight: bold;
      font-size: 30px;
      margin-top: 10px;
    }

  }
</style>